import React, { useState } from 'react';
import { ArrowLeft, Mail, Clock, Send, ShieldCheck, Trash2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const ContactUsPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSubmitted(true);
      setFormData({ name: '', email: '', subject: '', message: '' });
      setTimeout(() => setIsSubmitted(false), 4000);
    }, 1500);
  };

  return (
    <div className="privacy-policy">
      <div className="privacy-policy-container">
        <button className="back-button" onClick={() => navigate('/')}>
          <ArrowLeft size={20} />
          Back to Home
        </button>
        
        <div className="privacy-policy-content">
          <h1>Contact Us & Merchant Details</h1>
          <p className="last-updated">Official Business and Support Information</p>
          
          <section>
            <p>
              We are committed to providing prompt, transparent support for our users, software clients, and solar EPC partners. Whether you have questions regarding <strong>JustSolar</strong>, license activation, refunds, or custom development inquiries, our team is ready to assist you.
            </p>
          </section>

          <section>
            <h2>Legal Merchant & Entity Details</h2>
            <div className="merchant-card">
              <div className="merchant-item">
                <strong>Legal Name (as per PAN):</strong>
                <span>Pankaj Acharya</span>
              </div>
              <div className="merchant-item">
                <strong>Trade / Business Name:</strong>
                <span>JustLabs</span>
              </div>
              <div className="merchant-item">
                <strong>Business Entity Type:</strong>
                <span>Sole Proprietorship</span>
              </div>
              <div className="merchant-item">
                <strong>Country of Operation:</strong>
                <span>India</span>
              </div>
              <div className="merchant-item">
                <strong>Primary Operating Website:</strong>
                <span>https://justlabs.in</span>
              </div>
            </div>
          </section>

          <section>
            <h2>Customer Support & Direct Contact Channels</h2>
            <div className="contact-details-grid">
              <div className="contact-detail-box">
                <div className="detail-icon"><Mail size={24} /></div>
                <div>
                  <strong>Customer & Product Support</strong>
                  <p><a href="mailto:pankajacharyaorg@gmail.com">pankajacharyaorg@gmail.com</a></p>
                  <small>For JustSolar licenses, technical queries & activation</small>
                </div>
              </div>

              <div className="contact-detail-box">
                <div className="detail-icon"><Mail size={24} /></div>
                <div>
                  <strong>General Business Inquiries</strong>
                  <p><a href="mailto:pankajacharyaorg@gmail.com">pankajacharyaorg@gmail.com</a></p>
                  <small>For partnerships and custom Android projects</small>
                </div>
              </div>

              <div className="contact-detail-box">
                <div className="detail-icon"><Clock size={24} /></div>
                <div>
                  <strong>Operating Hours</strong>
                  <p>Monday to Saturday: 9:30 AM – 6:30 PM (IST)</p>
                  <small>Sundays and Indian National Holidays: Closed</small>
                </div>
              </div>

              <div className="contact-detail-box">
                <div className="detail-icon"><ShieldCheck size={24} /></div>
                <div>
                  <strong>Grievance Officer</strong>
                  <p>Pankaj Acharya</p>
                  <small>Email: <a href="mailto:pankajacharyaorg@gmail.com">pankajacharyaorg@gmail.com</a> (Response within 24–48 hours)</small>
                </div>
              </div>
            </div>
          </section>

          <section id="data-deletion">
            <h2>User Data Deletion Request</h2>
            <p>
              Under Google Play policies and privacy standards, users can request full deletion of their personal data, account information, and records associated with any of our applications (JustSolar, JustPDF, JustPrint, JustSaver, JustConverter).
            </p>
            <div className="data-deletion-card">
              <div className="data-deletion-header">
                <Trash2 size={22} color="#dc2626" />
                <h3>Want Your Data Deleted?</h3>
              </div>
              <p>
                To request permanent deletion of your data, please email us directly at <strong>pankajacharyaorg@gmail.com</strong>.
              </p>
              <p>
                Please include your registered email address, app name, and any license or transaction details in your email. We will process and permanently remove your data within <strong>48 to 72 business hours</strong>.
              </p>
              <a 
                href="mailto:pankajacharyaorg@gmail.com?subject=Data%20Deletion%20Request&body=Hello%20JustLabs%20Team%2C%0A%0AI%20would%20like%20to%20request%20the%20permanent%20deletion%20of%20all%20my%20data%20associated%20with%20your%20services%20and%20applications.%0A%0AMy%20details%3A%0A-%20Full%20Name%3A%20%0A-%20Registered%20Email%20Address%3A%20%0A-%20Application%20Name(s)%3A%20%0A-%20Device%20Identifier%20%2F%20Transaction%20ID%20(if%20any)%3A%20%0A-%20Additional%20Information%3A%20%0A%0AThank%20you."
                className="data-deletion-btn"
              >
                <Send size={16} />
                Send Email to Request Data Deletion
              </a>
              <div className="data-deletion-email-direct">
                Or email us directly at: <a href="mailto:pankajacharyaorg@gmail.com">pankajacharyaorg@gmail.com</a>
              </div>
            </div>
          </section>

          <section>
            <h2>Send Us a Direct Message</h2>
            <div className="contact-page-form">
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="contact-name">Full Name *</label>
                  <input
                    type="text"
                    id="contact-name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Enter your full name"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="contact-email">Email Address *</label>
                  <input
                    type="email"
                    id="contact-email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="name@company.com"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="contact-subject">Subject *</label>
                  <input
                    type="text"
                    id="contact-subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleInputChange}
                    placeholder="e.g., JustSolar License Activation / Inquiry"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="contact-message">Message *</label>
                  <textarea
                    id="contact-message"
                    name="message"
                    rows="5"
                    value={formData.message}
                    onChange={handleInputChange}
                    placeholder="Please include relevant details such as your Payment ID or project requirements..."
                    required
                  />
                </div>

                <button 
                  type="submit" 
                  className="submit-btn" 
                  disabled={isSubmitting || isSubmitted}
                >
                  {isSubmitting ? 'Sending Message...' : isSubmitted ? 'Message Sent Successfully!' : (
                    <>
                      <Send size={16} style={{ marginRight: '8px' }} />
                      Submit Inquiry
                    </>
                  )}
                </button>
              </form>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default ContactUsPage;
